<template lang="html">
  <section class="directors">
    <DirectorsHero ref="hero" :firstName="selectedDirector.firstName" :lastName="selectedDirector.lastName" :frontImage="selectedDirector.frontImage" :backImage="selectedDirector.backImage" :directorOpened="directorOpened" @handleOpen="openDirector" v-hammer:swipe="onSwipe"/>
    <div class="directors__controls">
      <transition name="fadeIn">
        <ul class="directors__dots" v-if="!directorOpened && directors.length > 1">
          <li class="directors__dot" :class="{selected:director.selected}" v-for="(director, index) in directors" @click="selectDirector(index)"></li>
        </ul>
      </transition>
      <transition name="fadeIn">
        <button class="directors__next hover" @click="goToNext" v-if="!directorOpened && directors.length > 1">next</button>
      </transition>
    </div>
    <transition name="fadeIn">
      <div class="directors__close hover" @click="goBack" v-if="directorOpened">back</div>
    </transition>
    <div class="directors__content" ref="content">
      <div class="directors__description">
        <div class="directors__info">
          <h3 class="monitor monitorHide">{{directorFullName}}</h3>
          <dl>
            <dt class="monitor monitorHide">Expertise</dt>
            <dd class="monitor monitorHide">{{selectedDirector.expertise}}</dd>
            <dt class="monitor monitorHide">Favorite Directors</dt>
            <dd class="monitor monitorHide" v-for="favDirector in selectedDirector.favDirectors">{{favDirector}}</dd>
            <dt class="monitor monitorHide">Favorite Toys</dt>
            <dd class="monitor monitorHide">{{selectedDirector.favToys}}</dd>
          </dl>
        </div>
        <div class="directors__about monitor monitorHide">
          <p class="monitor monitorHide" v-for="aboutPart in selectedDirector.about.split('\n')">{{aboutPart}}</p>
        </div>
      </div>
      <template v-if="directorWorks.length">
        <h2 class="title monitor monitorHide"><span>videos</span></h2>
        <div class="directors__list monitor monitorHide">
          <WorkItem v-for="work in directorWorks" :key="work.id" :image="work.image" :label="work.label" :tag="work.tag" :id="work.id"/>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import anime from 'animejs';
import scrollMonitor from 'scrollmonitor';
import DirectorsHero from '../components/DirectorsHero.vue';
import WorkItem from '../components/WorkItem.vue';

export default {
  name: 'Directors',
  components: {
    DirectorsHero,
    WorkItem
  },
  mounted() {
    document.querySelector('.directorsHero').style.height = window.innerHeight + 'px';
    setTimeout(() => {
      var elementList = document.querySelectorAll(".monitor");
      elementList.forEach(element => {
        var elementWatcher = scrollMonitor.create(element);
        elementWatcher.enterViewport(function() {
          element.classList.remove('monitorHide');
        });
        elementWatcher.exitViewport(function() {
          element.classList.add('monitorHide');
        });
      });
    }, 1000)
    document.querySelector('body').style.overflow = 'hidden';
    setTimeout(() => {
      window.scrollTo(0,0);
    }, 200);
    anime({
      targets: '.directorsHero__title span',
      translateY: ["1.1em", 0],
      translateZ: 0,
      duration: 2000,
      easing: 'easeInOutCubic',
      delay: 1000
    });
    anime({
      targets: '.directorsHero__subtitle span',
      translateX: ["-200%", 0],
      translateZ: 0,
      duration: 1000,
      easing: 'easeInOutCubic',
      delay: 1000
    });
    anime({
      targets: ['.directors__dots', '.directors__next'],
      opacity: [0,1],
      duration: 1000,
      easing: 'easeInOutCubic',
      delay: 2000
    });
  },
  beforeRouteLeave(to, from, next) {
    document.querySelector('body').style.overflow = 'hidden auto';
    next()
  },
  data() {
    return {
      directorOpened: false
    }
  },
  watch: {
    lang(newVal, oldVal) {
      setTimeout(() => {
        var elementList = document.querySelectorAll(".monitor");
        elementList.forEach(element => {
          var elementWatcher = scrollMonitor.create(element);
          elementWatcher.enterViewport(function() {
            element.classList.remove('monitorHide');
          });
          elementWatcher.exitViewport(function() {
            element.classList.add('monitorHide');
          });
        });
      }, 1000);
    }
  },
  computed: {
    directors() {
      return this.$store.getters.visibleDirectors;
    },
    selectedDirector() {
      return this.directors.find(director => director.selected) || {firstName:'',lastName:'',frontImage:'',backImage:'',expertise:'',favDirectors:[],favToys:'',about:'',selected:true};
    },
    directorFullName() {
      return this.selectedDirector.firstName + " " + this.selectedDirector.lastName
    },
    directorWorks() {
      return this.$store.state.works.filter(work => work.director === this.directorFullName)
    },
    lang() {
      return this.$store.state.lang;
    }
  },
  methods: {
    scrollToPosition(position) {
      window.scrollTo({
        top: position,
        left: 0,
        behavior: 'smooth'
      });
    },
    onSwipe(e) {
      if (this.directorOpened) return;
      if (e.direction === 2) this.goToNext();
      else if (e.direction === 4) this.goToPrev();
    },
    openDirector() {
      this.directorOpened = true;
      document.querySelector('body').style.overflow = 'hidden auto';
      setTimeout(() => {
        this.scrollToPosition(this.$refs.content.offsetTop);
      }, 1500)
    },
    goBack() {
      this.directorOpened = false;
      document.querySelector('body').style.overflow = 'hidden';
      this.scrollToPosition(0);
    },
    goToNext() {
      let currentIndex = this.directors.indexOf(this.directors.find(director => director.selected)) + 1;
      if (currentIndex >= this.directors.length) currentIndex = 0;
      this.slideTransition();
      setTimeout(() => {
        this.$store.commit('changeSelectedDirector', currentIndex);
      },400)
    },
    goToPrev() {
      let currentIndex = this.directors.indexOf(this.directors.find(director => director.selected)) - 1;
      if (currentIndex < 0) currentIndex = this.directors.length - 1;
      this.slideTransition();
      setTimeout(() => {
        this.$store.commit('changeSelectedDirector', currentIndex);
      },400)
    },
    selectDirector(index) {
      this.slideTransition();
      setTimeout(() => {
        this.$store.commit('changeSelectedDirector', index);
      }, 400)
    },
    slideTransition() {
      const hero = this.$refs.hero.$el;
      let name = hero.querySelector('.directorsHero__name');
      // name.style.transform = 'translate(-40px, 0)';
      name.style.opacity = 0;
      hero.style.opacity = 0;
      setTimeout(() => {
        name = hero.querySelector('.directorsHero__name');
        // name.style.transform = 'translate(40px, 0)';
      },400)
      setTimeout(() => {
        // name.style.transform = 'translate(0,0)';
        hero.style.opacity = 1;
        name.style.opacity = 1;
        anime({
          targets: '.directorsHero__title span',
          translateY: ["1.1em", 0],
          translateZ: 0,
          duration: 2000,
          easing: 'easeInOutCubic'
        });
        anime({
          targets: '.directorsHero__subtitle span',
          translateX: ["-200%", 0],
          translateZ: 0,
          duration: 1000,
          easing: 'easeInOutCubic'
        });
      },800)
    }
  }
}
</script>

<style lang="scss">
@import "../styles/config.scss";
.directors {
  padding: 100px 0 0;
  .monitor {
    opacity: 1;
    transition: all .5s ease-out .3s;
  }
  .monitorHide {
    opacity: 0 !important;
    transform: translateY(80px)!important;
  }
  &__controls {
    width: 100%;
    max-width: 1240px;
    position: absolute;
    top: 90vh;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 20px;
    text-align: center;
  }
  &__dots {
    display: inline-block;
    transition: opacity .2s ease-out;
  }
  &__dot {
    border-radius: 5px;
    border: 1px solid var(--Neu01);
    width: 6px;
    height: 6px;
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
    transition: border-color .2s ease-in, width .3s ease-in;
    &.selected {
      border-color: var(--M01);
      width: 50px;
      transition: border-color .2s ease-in .3s, width .6s cubic-bezier(.41,.15,.41,1.31) .2s;
    }
  }
  &__next {
    background-color: transparent;
    border: none;
    margin: 0;
    font-family: CamptonBold;
    font-size: 20px;
    color: var(--Neu01);
    overflow: hidden;
    margin-left: 40px;
  }
  &__close {
    font-family: CamptonBold;
    font-size: 12px;
    color: var(--Neu01);
    display: inline-block;
    padding-top: 12px;
    position: fixed;
    bottom: 40px;
    left: 20px;
    z-index: 1;
    background-color: var(--Neu10);
    box-shadow: 0 0 20px var(--Neu10);
    border-radius: 50%;
    padding: 32px 18px 21px;
    &:before,&:after {
      content: '';
      display: block;
      height: 4px;
      border-radius: 5px;
      border: 1px solid var(--M01);
      top: 20px;
      position: absolute;
    }
    &:before {
      width: 4px;
      left: 16px;
    }
    &:after {
      width: 20px;
      left: 27px;
    }
  }
  &__content {
    margin-top: 100vh;
    background-color: var(--Neu10);
    // width: calc(100% + 40px);
    // left: -20px;
    padding: 160px 20px 140px;
    .workItem:after {
      top: 20%;
    }
  }
  &__description {
    font-size: 0;
    max-width: 840px;
    width: 100%;
    margin: 0 auto;
    padding-bottom: 80px;
  }
  &__info,
  &__about {
    width: 50%;
    display: inline-block;
    vertical-align: top;
  }
  &__info {
    h3 {
      font-family: CamptonBold;
      font-size: 27px;
      line-height: 32px;
      color: var(--Neu01);
      max-width: 200px;
      margin-bottom: 50px;
    }
    dl {
      max-width: 260px;
    }
    dt {
      font-family: CamptonBold;
      font-size: 14px;
      color: var(--Neu01);
      margin-top: 40px;
      margin-bottom: 10px;
    }
    dd {
      font-family: CamptonBook;
      font-size: 14px;
      line-height: 1.29;
      color: var(--Neu06);
    }
  }
  &__about {
    p {
      font-family: CamptonBook;
      font-size: 18px;
      line-height: 1.5;
      color: var(--Neu01);
      margin-bottom: 20px;
    }
  }
  &__list {
    margin: 40px auto 0;
    width: 100%;
    max-width: 1240px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 40px;
    grid-column-gap: 20px;
  }
  .workItem {
    opacity: 1;
    &__image {
      max-width: none;
      height: 300px;
    }
  }
  @include mq(0,768px) {
    &__controls {
      top: 80vh;
      left: 50%;
      height: auto;
    }
    &__next {
      margin-left: 20px;
    }
    &__dots {
      left: 0;
    }
    &__scroll {
      top: 150px;
    }
    &__content {
      padding: 80px 20px 40px;
      .workItem:after {
        top: 10%;
      }
    }
    &__info,
    &__about {
      width: 100%;
    }
    &__info {
      margin-bottom: 40px;
      h3 {
        max-width: none;
        margin-bottom: 30px;
      }
      dt {
        margin-top: 20px;
        margin-bottom: 10px;
      }
      dl {
        max-width: none;
      }
    }
    &__about {
      margin-bottom: 40px;
      p {
        font-family: CamptonBook;
        font-size: 18px;
        line-height: 1.5;
        color: var(--Neu01);
      }
    }
    &__description {
      padding-bottom: 0;
    }
    &__list {
      margin-top: 20px;
      grid-template-columns: repeat(1, 1fr);
    }
  }
}
@keyframes slideDown {
  0% {
    transform: rotate(270deg) translateX(20px);
  }
  100% {
    transform: rotate(270deg) translateX(-50px);
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Directors.vue